























































































import { Component, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";
import moment from "moment";
import { I18N } from "@/config";
import CryptoCompareService from "@/services/crypto-compare";
import { ListDivided, ListDividedItem } from "@/components/utils/listDivided";

@Component({
  components: {
    ListDivided,
    ListDividedItem,
  },
  computed: {
    ...mapGetters("network", { networkCurrencies: "currencies", networkDefaults: "defaults" }),
  },
})
export default class SettingsModal extends Vue {
  private networkCurrencies: string[];
  private networkDefaults: any;
  private currencyName: string;
  private currencySymbol: string;
  private smartbridgeFilter = "filtered";
  private nightMode: boolean;
  private chartMode: boolean;
  private language: string;
  private isAcceptTerms = false;
  private notShowDisclaimer = false;
  private isLoading = false;

  private readonly smartbridgeFilterTypes = {
    unfiltered: "COMMON.UNFILTERED",
    filtered: "COMMON.FILTERED",
    hidden: "COMMON.HIDDEN",
  };

  get showCurrency(): boolean {
    return this.networkDefaults.priceChartOptions.enabled;
  }

  get selectCurrencies() {
    return Object.keys(this.networkCurrencies).map((currency: string) => ({
      value: currency,
      display: currency,
    }));
  }

  get selectSmartbridgeFilter() {
    return Object.keys(this.smartbridgeFilterTypes).map((type: string) => ({
      value: type,
      display: this.$t(this.smartbridgeFilterTypes[type]),
    }));
  }

  get selectLanguages() {
    return Object.keys(I18N.languages).map((language: string) => ({
      value: language,
      display: I18N.languages[language],
    }));
  }

  // No longer show the disclaimer if the user has accepted the terms
  get showDisclaimer() {
    return this.smartbridgeFilter === "unfiltered" && !this.notShowDisclaimer;
  }

  get hasAcceptedTerms() {
    return this.isAcceptTerms;
  }

  public created() {
    this.currencyName = this.$store.getters["currency/name"];
    this.currencySymbol = this.$store.getters["currency/symbol"];
    this.smartbridgeFilter = this.$store.getters["ui/smartbridgeFilter"];
    this.nightMode = this.$store.getters["ui/nightMode"];
    this.chartMode = this.$store.getters["ui/priceChartOptions"].enabled;
    this.language = this.$store.getters["ui/language"];

    if (this.smartbridgeFilter === "unfiltered") {
      this.isAcceptTerms = true;
      this.notShowDisclaimer = true;
    }
  }

  private onSelectChange(event: any) {
    const { name, value } = event.target;

    if (name === "currency") {
      this.currencyName = value;
      this.currencySymbol = this.networkCurrencies[value];
    } else if (name === "smartbridge-filter") {
      this.smartbridgeFilter = value;
      this.isAcceptTerms = false;
      this.notShowDisclaimer = false;
    } else if (name === "language") {
      this.language = value;
    }
  }

  private storeCurrency(currency: string, rate: number, symbol: string) {
    this.$store.dispatch("currency/setName", currency);
    this.$store.dispatch("currency/setRate", rate);
    this.$store.dispatch("currency/setSymbol", symbol);
  }

  private setLanguage(language: string) {
    this.$store.dispatch("ui/setLanguage", language);
    this.$i18n.locale = language;

    this.$store.dispatch("ui/setLocale", language);
    moment.locale(language);
  }

  private toggleAcceptTerms() {
    this.isAcceptTerms = !this.isAcceptTerms;
  }

  private toggleTheme() {
    this.nightMode = !this.nightMode;
  }

  private toggleChart() {
    this.chartMode = !this.chartMode;
  }

  private async save() {
    this.isLoading = true;

    if (this.currencyName !== this.$store.getters["currency/name"]) {
      const rate = await CryptoCompareService.price(this.currencyName);
      this.storeCurrency(this.currencyName, rate!, this.currencySymbol);
    }

    if (this.smartbridgeFilter !== this.$store.getters["ui/smartbridgeFilter"]) {
      this.$store.dispatch("ui/setSmartbridgeFilter", this.smartbridgeFilter);
    }

    if (this.nightMode !== this.$store.getters["ui/nightMode"]) {
      this.$store.dispatch("ui/setNightMode", this.nightMode);
    }

    if (this.chartMode !== this.$store.getters["ui/priceChartOptions"].enabled) {
      this.$store.dispatch("ui/setPriceChartOption", { option: "enabled", value: this.chartMode });
    }

    if (this.language !== this.$store.getters["ui/language"]) {
      this.setLanguage(this.language);
    }

    this.isLoading = false;
    this.emitClose();
  }

  public emitClose() {
    this.$emit("close");
  }
}
